"use client";

import { Suspense } from "react";
import { Header } from "@/components/layout/header";
import { Footer } from "@/components/layout/footer";
import { SystemStatusBanner } from "@/components/layout/systemStatusBanner";
import { usePathname } from "next/navigation";

const immersiveRoutes = ["/concierge", "/chat", "/plan"];

const MainLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const pathname = usePathname();
  const isImmersiveRoute = immersiveRoutes.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`)
  );

  return (
    <div
      className={
        isImmersiveRoute
          ? "min-h-dvh overflow-hidden md:min-h-screen"
          : "min-h-screen"
      }
    >
      {/* Publishes --status-banner-height, which the fixed header offsets from
          and the content padding below adds to. Stays 0px when no banner shows. */}
      <SystemStatusBanner />
      <div className={isImmersiveRoute ? "hidden md:block" : undefined}>
        <Suspense
          fallback={
            <div className="h-[75px] bg-background md:border-b md:border-foreground/10" />
          }
        >
          <Header />
        </Suspense>
      </div>
      <div
        className={
          isImmersiveRoute
            ? "pt-[var(--status-banner-height,0px)] md:pt-header"
            : "pt-header"
        }
      >
        {children}
      </div>
      {isImmersiveRoute ? null : <Footer />}
    </div>
  );
};

export default MainLayout;
